var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{attrs:{"name":"filtration","width":14,"height":9}},[_c('path',{attrs:{"d":"M5.25 9H8.25V7.5H5.25V9ZM0 0V1.5H13.5V0H0ZM2.25 5.25H11.25V3.75H2.25V5.25Z","fill":_vm.fill}})])}
var staticRenderFns = []

export { render, staticRenderFns }